import { Button, Chip, Fab, IconButton, Select, styled, TextField } from '@mui/material';

import theme from 'styles/theme';

export const PageRoot = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const TitleRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 16px;
`;

export const PageTitle = styled('h2')`
  font-size: 20px;
  color: #999;
  margin: 0;
  white-space: nowrap;
`;

export const MobileSearchRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const ToolbarRow = styled('div')`
  display: flex;
  align-items: center;
  padding-bottom: 16px;
`;

export const ToggleGroup = styled('div')`
  display: flex;
  gap: 8px;
`;

export const ToggleBtn = styled('button', {
  shouldForwardProp: (prop) => prop !== '$active',
})<{ $active?: boolean }>`
  height: 44px;
  padding: 12px 32px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white.main};
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: ${({ theme, $active }) =>
    $active ? `1px solid ${theme.palette.info.main}` : '1px solid #E0E0E0'};
  color: ${({ theme, $active }) =>
    $active ? theme.palette.info.main : theme.palette.primary.main};

  @media (max-width: 1023px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

export const ToolbarActions = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

export const IconBtn = styled(IconButton)`
  height: 44px;
  width: 44px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  background: ${({ theme }) => theme.palette.white.main};
`;

export const CardsW = styled('div', {
  shouldForwardProp: (prop) => prop !== 'viewMode',
})<{ viewMode?: 'grid' | 'list' }>`
  display: grid;
  grid-template-columns: ${({ viewMode }) =>
    viewMode === 'list' ? '1fr' : 'repeat(auto-fit, minmax(360px, 1fr))'};
  gap: 8px;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

export const CardW = styled('div')`
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ theme }) => theme.palette.white.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 12px;

  padding: 14px 16px;
  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.palette.info.main};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
`;

export const RightW = styled('div')`
  flex: 1;
  flex-direction: row;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const SearchW = styled('div')`
  flex: 1;
  max-width: 558px;
  height: 56px;
  margin-left: 80px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.white.light};
  border: 1px solid ${({ theme }) => theme.palette.primary.p010};
  border-radius: 8px;
  padding: 8px 18px;
  gap: 10px;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    opacity: 0.45;
  }

  @media (max-width: 1023px) {
    max-width: 200px;
  }
`;

export const SearchInput = styled(TextField)`
  width: 320px;
  border: 0px;

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const CreateButton = styled(Button)`
  height: 56px;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.palette.info.main};
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  border-radius: 8px;
  text-transform: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.info.main};
    opacity: 0.8;
  }
`;

export const FilterSelect = styled(Select)`
  height: 44px;
  min-width: 160px;
  background: #fff;

  & .MuiSelect-select {
    padding-right: 14px !important;
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.palette.primary.grey};
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
    border-color: ${theme.palette.primary.grey};
  }
`;

export const FilterChip = styled(Chip)`
  background: ${theme.palette.info.light};
  color: ${theme.palette.info.main};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${theme.palette.info.main};

  & .MuiChip-deleteIcon {
    color: ${theme.palette.info.main};
    font-size: 16px;

    &:hover {
      color: ${theme.palette.info.dark};
    }
  }
`;

export const FilterChipsRow = styled('div')`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding-bottom: 16px;
`;

export const ClearSearchBtn = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.35);
  flex-shrink: 0;

  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }

  svg {
    width: 16px;
    height: 16px;
    opacity: 1;
  }
`;

export const MobileFab = styled(Fab)`
  position: fixed;
  bottom: 100px;
  right: 16px;
  background-color: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0 4px 12px rgba(0, 150, 235, 0.4);
`;
